import { render, staticRenderFns } from "./Childs.vue?vue&type=template&id=aa698e9e&"
import script from "./Childs.vue?vue&type=script&lang=js&"
export * from "./Childs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports